import * as React from "react";
import ContactView from "../presentation/contact";
export default class Contact extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(ContactView, null));
    }
}
;
//# sourceMappingURL=contact.js.map